import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import {
  Button,
  Container,
  Menu,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import { flashSuccessMessage, flashErrorMessage } from '../../actions/flash';
import { fetchM } from '../../actions/fetchM';
import config from '../../../config';
import NavBar from '../../components/NavBar';
import Form from './Form';
import { namespaces } from '../../constants/translation';

class New extends Component {
  static propTypes = {
    location: PropTypes.shape({
      hash: PropTypes.string,
    }),
    loading: PropTypes.bool,
    auth: PropTypes.shape({
      companyBranch: PropTypes.shape({
        id: PropTypes.number,
      }),
      isHeadquarters: PropTypes.bool,
    }),
    t: PropTypes.func,
  }
  static contextTypes = {
    store: PropTypes.object,
  }
  static mapStateToProps = state => ({
    auth: state.auth,
  })

  constructor(props) {
    super(props);
    this.state = {
      token: null,
    };
  }
  componentDidMount() {
    this.getToken();
  }
  async getToken() {
    const { store } = this.context;
    let res;
    try {
      res = await store.dispatch(fetchM(`${config.get('bookApiURL')}/company_branches/?token`, {
        credentials: 'include',
        method: 'GET',
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: 'An error occurred, please refresh page' }));
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const token = res.headers.get('X-Csrf-Token');
      this.setState({
        token,
      });
    }
  }
  async submit(validations, businessUnitData) {
    const { store } = this.context;
    const businessUnit = Object.assign({}, businessUnitData);
    const errors = validations.filter(v => !v.isValid);
    if (errors.length > 0) {
      store.dispatch(flashErrorMessage({ header: 'Please fix form errors', list: errors.map(l => l.message) }));
      return;
    }
    businessUnit.reservationLimit = parseInt(businessUnitData.reservationLimit, 10);
    try {
      await this.form.submit(`${config.get('bookApiURL')}/company_branches/`, {
        credentials: 'include',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.state.token,
        },
        body: JSON.stringify(businessUnit),
      });
    } catch (err) {
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      store.dispatch(flashErrorMessage(err));
      return;
    }
    store.dispatch(push('/business_units/'));
    store.dispatch(flashSuccessMessage({ header: 'Create Success', message: `${businessUnit.name} successfully created` }));
  }
  handleSubmit = (event) => {
    event.preventDefault();
    const { store } = this.context;
    this.form.handleSubmit(event)
      .catch((err) => {
        Bugsnag.notifyException(err);
        store.dispatch(flashErrorMessage(err));
      });
  }
  render() {
    const { t } = this.props;
    return (
      <Container>
        <NavBar
          header={t('New')}
          rightNav={
            <Menu.Item fitted>
              <Button
                positive
                content={t('Create')}
                onClick={this.handleSubmit}
              />
            </Menu.Item>
          }
        />
        <Form
          ref={(ref) => { this.form = ref; }}
          onSubmit={(validations, businessUnit) => {
            this.submit(validations, businessUnit);
          }}
          location={this.props.location}
          auth={this.props.auth}
          loading={this.props.loading}
        />
      </Container>
    );
  }
}

export default withTranslation([
  ...namespaces,
])(connect(New.mapStateToProps)(New));



// WEBPACK FOOTER //
// ./src/containers/BusinessUnits/New.jsx